import angular from 'angular';
import AuthService from './auth.service';
import PasswordRecoveryService from './password-recovery.service';
import AccountInformationService from './account-information.service';
import LoginService from './login.service';
import ContentService from './content.service';
import RegisterService from './register.service';
import PollerService from './poller.service';
import DashboardService from './dashboard.service';
import PermissionsService from './permissions.service';
import ProfilePermissionsService from './profile-permissions.service';
import AdminService from './admin.service';
import MasterService from './master.service';
import ExceptionsService from './exceptions.service';
import FiscalPrinterService from './fiscal-printer.service';
import CountriesService from './countries.service';
import TimezonesService from './timezones.service';
import SubscriptionService from './subscribe.service';

let serviceModule = angular.module('app.serviceModule', [
])
.service('$poller', PollerService)
.service('AuthService', AuthService)
.service('PasswordRecoveryService', PasswordRecoveryService)
.service('AccountInformationService', AccountInformationService)
.service('LoginService', LoginService)
.service('ContentService', ContentService)
.service('RegisterService', RegisterService)
.service('DashboardService', DashboardService)
.service('PermissionsService', PermissionsService)
.service('ProfilePermissionsService', ProfilePermissionsService)
.service('AdminService', AdminService)
.service('ExceptionsService', ExceptionsService)
.service('MasterService', MasterService)
.service('FiscalPrinterService', FiscalPrinterService)
.service('CountriesService', CountriesService)
.service('TimezonesService', TimezonesService)
.service('SubscriptionService', SubscriptionService)
.name;

export default serviceModule;



// WEBPACK FOOTER //
// ./src/app/services/services.js